import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

export interface RoutingConfig {
    id?: string;
    land: string;
    tile_url: string;
    routing_url: string;
    provider_order: string[];
    active: boolean;
}

export function useRoutingConfig(land: string = "nl") {
    return useQuery<RoutingConfig>({
        queryKey: ["/api/osm/config", land.toLowerCase()],
        queryFn: async () => {
            const response = await fetch(`/api/osm/config/${land.toLowerCase()}`);
            if (!response.ok) throw new Error("Failed to fetch routing config");
            return response.json();
        },
        staleTime: 300000, // 5 minutes
    });
}
